import React, { Component } from "react";
import { connect } from "react-redux";
import { loginAction } from "./loginActions";
import LoginView from "./LoginView";
import "../../css/authForm.css";

class LoginContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      phoneNumber: "",
      password: "",
      error: false,
      errorMsg: "",
      serverErrorText: "",
      serverError: false
    };
  }

  /**
   * @function handleChange
   * @param e
   * @desc This handles the phone number and password input changes
   */
  handleChange = e => {
    const { name, value } = e.target;
    this.setState({
      [name]: value.replace(/\s/g, ""),
      error: false,
      errorMsg: "",
      serverError: false,
      serverErrorText: ""
    });
  };

  /**
   * @function setStateForInvalidData
   * @param errorText
   * @return nothing
   * @desc This method sets error messages state
   */
  setStateForInvalidData = errorText => {
    this.setState({
      error: true,
      errorMsg: errorText,
      serverError: false,
      serverErrorText: ""
    });
  };

  /**
   * @function handleSubmit
   * @param e
   * @desc This handles the submission of login parameters, calls login action
   */
  handleSubmit = e => {
    e.preventDefault();

    const { phoneNumber, password } = this.state;
    if (!phoneNumber || !password) {
      this.setStateForInvalidData("phone_and_password_required");
      return;
    }

    if (phoneNumber && password) {
      this.props.loginUser(phoneNumber, password);
    }
  };

  /**
   * @function processErrors
   * @param errors
   * @param nothing
   * @desc This handles setting state
   *  of variable which
   * is to be shown to the user
   *  when api returns some error
   */
  processErrors = errors => {
    let error = "";
    if (errors instanceof Array) {
      // eslint-disable-next-line prefer-destructuring
      error = errors[0];
    } else {
      error = errors;
    }

    switch (error.source) {
      case "password":
        this.setState({
          serverErrorText: "invalid_password"
        });
        break;
      case "mobile_number_or_password":
        this.setState({
          serverErrorText: "invalid_username_pwd"
        });
        break;
      default:
        this.setState({
          serverErrorText: "error_msg"
        });
        break;
    }
  };

  UNSAFE_componentWillReceiveProps(newProps) {
    if (newProps.loginError) {
      this.setState({ error: false, errorMsg: "", serverError: true });
      this.processErrors(newProps.loginError);
    }
  }

  render() {
    return (
      <LoginView
        handleChange={this.handleChange}
        handleSubmit={this.handleSubmit}
        isProcessing={this.props.isProcessing}
        error={this.state.error}
        errorMsg={this.state.errorMsg}
        phoneNumber={this.state.phoneNumber}
        password={this.state.password}
        loginError={this.props.loginError}
        serverError={this.state.serverError}
        serverErrorText={this.state.serverErrorText}
      />
    );
  }
}

const mapStateToProps = state => ({
  isProcessing: state.login.isProcessing,
  loginError: state.login.error
});

const mapDispatchToProps = dispatch => ({
  loginUser: (phoneNumber, password) =>
    dispatch(loginAction(phoneNumber, password))
});

const connectedPage = connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginContainer);
export { connectedPage as default };
